import React from "react";
import Article from "../article";
import styled from "styled-components";
import { H2 } from "./articles.components";

const StyledContent = styled.section`
  line-height: 1.8;
  margin: 20px 0;

  p {
    margin-bottom: 16px;
    text-align: justify;
  }

  ul {
    margin-bottom: 16px;
    padding-left: 20px;
  }
`;

function WhatChangesKw(props) {
    return (
        <Article {...props}>
            <StyledContent>
                <H2>Co najczęściej się zmienia w księdze wieczystej?</H2>
                <p>
                    Księga wieczysta jest oficjalnym rejestrem prawa własności nieruchomości oraz wszelkich obciążeń i ograniczeń związanych z nieruchomością. Zmiany wpisów odzwierciedlają aktualne zdarzenia prawne, dlatego warto znać najczęstsze przyczyny tych modyfikacji.
                </p>
                <ul>
                    <li>
                        <strong>Zmiana właściciela nieruchomości:</strong> sprzedaż, darowizna, zamiana czy dziedziczenie – każda transakcja własnościowa skutkuje nowym wpisem w dziale II.
                    </li>
                    <li>
                        <strong>Ustanowienie lub wykreślenie hipoteki:</strong> banki i instytucje finansowe zabezpieczają kredyty hipoteczne wpisem w dziale IV; wykreślenie następuje po spłacie całości zobowiązania.
                    </li>
                    <li>
                        <strong>Służebności i użytkowanie wieczyste:</strong> prawo drogi, służebność przesyłu czy użytkowanie wieczyste – zmiany w dziale III i IV wpływają na sposób korzystania z nieruchomości.
                    </li>
                    <li>
                        <strong>Podział, scalanie i zmiana granic działek:</strong> decyzje geodezyjne powodują aktualizację opisu nieruchomości i numeracji działek w księdze.
                    </li>
                    <li>
                        <strong>Zmiana przeznaczenia nieruchomości:</strong> przekształcenia rolnych działek na budowlane lub usługowe wymagają wpisów uaktualniających dane w rejestrze.
                    </li>
                    <li>
                        <strong>Aktualizacja danych osobowych:</strong> korekta nazwiska, adresu czy numeru PESEL właściciela w przypadku zmiany stanu cywilnego lub danych identyfikacyjnych.
                    </li>
                </ul>

                <H2>Podstawa prawna zmian</H2>
                <p>
                    Procedurę wprowadzania i wykreślania wpisów w księdze wieczystej reguluje ustawa z dnia 6 lipca 1982 r. o księgach wieczystych i hipotece. Zgodnie z art. 24–26, każda zmiana wymaga złożenia wniosku na formularzu KW wraz z dokumentami potwierdzającymi zdarzenie prawne oraz dowodem uiszczenia opłaty sądowej.
                </p>
                <p>
                    Sąd rejonowy rozpatruje wniosek, dokonuje wyjaśnień i wydaje postanowienie o wpisie. Czas oczekiwania zależy od obciążenia wydziału ksiąg wieczystych, ale w praktyce wnioski są realizowane od kilku dni do kilku tygodni.
                </p>

                <H2>Przykłady praktyczne</H2>
                <p>
                    W 2024 r. w jednym z powiatów gmina wniosła o zmianę przeznaczenia działki z rolnej na budowlaną. Dzięki szybkiemu wpisowi w księdze wieczystej inwestor mógł rozpocząć budowę planowanego osiedla, przyspieszając proces formalny o kilka tygodni.
                </p>
                <p>
                    Z kolei przypadek samowolnego użytkowania działki: nowy właściciel nie zgłosił służebności dojścia do drogi publicznej. Po interwencji sądowej służebność została wpisana, zapewniając dostęp do drogi i unikając sporów sąsiedzkich.
                </p>

                <H2>Jak często weryfikować wpisy?</H2>
                <p>
                    Zalecane jest sprawdzanie stanu księgi wieczystej przed każdą istotną transakcją (sprzedaż, kredyt, darowizna) oraz przynajmniej raz w roku w celach kontrolnych. Regularność monitoringu zmniejsza ryzyko nieautoryzowanych wpisów i pomaga w utrzymaniu aktualnej dokumentacji.
                </p>
                <p>
                    W ramach codziennej praktyki zawodowej notariusze i pośrednicy nieruchomości często łączą monitoring ksiąg z analizą innych rejestrów, takich jak ewidencja gruntów czy CEIDG, aby uzyskać pełny obraz prawny nieruchomości.
                </p>

                <H2>Podsumowanie</H2>
                <p>
                    Znajomość najczęstszych przyczyn zmian w księdze wieczystej oraz procedur ich zgłaszania jest kluczowa dla każdego uczestnika rynku nieruchomości. Weryfikacja wpisów zabezpiecza przed ryzykiem prawnym, pozwala uniknąć opóźnień w transakcjach oraz chroni interesy właścicieli i inwestorów.
                </p>
                <p>
                    Dzięki dostępowi do elektronicznej księgi wieczystej oraz narzędziom do monitoringu możesz na bieżąco kontrolować stan prawny nieruchomości i szybko reagować na zmiany.
                </p>
            </StyledContent>
        </Article>
    );
}

export default WhatChangesKw;
